/* =============================================================================
   vp-gift-cart.js — Gratis-Produkt automatisch in den Warenkorb   (21.10.2026)

   Wunsch Ursula (21.10.): Das Geschenk soll auf der Rechnung als eigene
   Position stehen, "als ob es ein gekauftes Produkt ist", mit dem Wert
   gratis — damit der Kunde den Wert sieht und das Lager automatisch weiss,
   was zu packen ist.

   ZWEI TEILE
   1. Shopify-Rabatt "Gratis-Geschenk" (automatischer Kauf-X-erhalte-Y-
      Rabatt, Shopify > Rabatte): ab 100 EUR aus "Shop All" wird 1 Stueck
      der Geschenk-Variante 100 % rabattiert. Shopify legt Gratis-Artikel
      aber NICHT von selbst in den Warenkorb.
   2. Dieses Skript: legt die Geschenk-Variante als eigene Position in den
      Warenkorb, sobald die uebrigen Artikel den Mindestwert erreichen, und
      nimmt sie wieder heraus, wenn der Wert darunter faellt. Die Position
      traegt die sichtbare Eigenschaft "Geschenk: gratis" (EN "Gift: free")
      und die versteckte Markierung _vp_gift. So steht sie mit 0 EUR in
      Warenkorb, Kasse, Bestellung, Rechnung (Sufio) und Packliste (Make).

   KONFIGURATION: im Theme-Editor, Footer > "Geschenk-Pop-up", Abschnitt
   "Gratis-Produkt im Warenkorb" (Produkt, Variante, Mindestwert). Zeitraum
   wie beim Pop-up. Die Sektion schreibt das als JSON in
   #vp-gift-cart-config. Bei einer neuen Aktion: dort das Produkt tauschen
   UND den Shopify-Rabatt anpassen bzw. neu anlegen.

   REGELN
   - Mindestwert: Summe der UEBRIGEN Positionen nach Artikelrabatten, vor
     Rabattcodes (ein Code wie ULLI15 nimmt das Geschenk also nicht weg).
   - Nur in EUR-Warenkoerben und nicht fuer die Laender, die in der Sektion
     ausgeschlossen sind (Standard CH, LI: Zoll-Zweig im Lager-Szenario
     wuerde eine 0-EUR-Position an ondot melden).
   - Menge des Geschenks bleibt 1. Die Mengenauswahl ist an der Position
     ausgeblendet.
   - Nimmt der Kunde das Geschenk selbst heraus, wird es in dieser Sitzung
     nicht erneut hinzugefuegt (sessionStorage).

   WANN GEPRUEFT WIRD
   Beim Laden, beim Oeffnen der Warenkorb-Schublade und nach jeder Aenderung
   am Warenkorb. Letzteres erkennt das Skript, indem es window.fetch
   umschliesst und nach Aufrufen von /cart/add, /cart/change, /cart/update
   und /cart/clear prueft — so muss keine Theme-Datei angefasst werden.
   Eigene Aufrufe laufen ueber das urspruengliche fetch und loesen keine
   Schleife aus.

   Nach einer eigenen Aenderung werden Warenkorb-Schublade bzw.
   Warenkorb-Seite und Zaehler genauso neu aufgebaut, wie das Theme es tut
   (cart.js, CartItems.getSectionsToRender).

   GRENZE: Express-Kaufknoepfe (Kauf ohne Warenkorb) umgehen den Warenkorb —
   dann kommt kein Geschenk dazu.

   ZURUECKNEHMEN: in der Sektion den Haken "Gratis-Produkt automatisch in
   den Warenkorb legen" entfernen; den Shopify-Rabatt deaktivieren.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__vpGiftCart) return;
  window.__vpGiftCart = true;

  var cfgEl = document.getElementById('vp-gift-cart-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.enabled || !cfg.variantId) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var FLAG = '_vp_gift';
  var KEY_DECLINED = 'vpGiftDeclined:' + cfg.variantId;
  var KEY_HAD = 'vpGiftHad:' + cfg.variantId;
  var origFetch = window.fetch.bind(window);

  var busy = false;
  var again = false;
  var timer = null;

  /* ---------------------------------------------------------------------- */

  function ss(get, key, val) {
    try {
      if (get) return sessionStorage.getItem(key);
      if (val === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, val);
    } catch (e) {}
    return null;
  }

  function todayVienna() {
    try {
      return new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Vienna', year: 'numeric', month: '2-digit', day: '2-digit'
      }).format(new Date());
    } catch (e) {
      var d = new Date();
      var p = function (n) { return (n < 10 ? '0' : '') + n; };
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
    }
  }

  function validDate(s) { return /^\d{4}-\d{2}-\d{2}$/.test(s || ''); }

  function inWindow() {
    var t = todayVienna();
    if (validDate(cfg.start) && t < cfg.start) return false;
    if (validDate(cfg.end) && t > cfg.end) return false;
    return true;
  }

  function isGift(item) {
    return !!(item && item.properties && item.properties[FLAG]);
  }

  function cartBase() {
    var u = (window.routes && window.routes.cart_url) || '/cart';
    return u.replace(/\/$/, '');
  }

  function postJSON(url, body) {
    return origFetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return origFetch(cartBase() + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.json(); });
  }

  /* --- Anzeige neu aufbauen (wie cart.js im Theme) ----------------------- */

  function sectionLists() {
    var lists = [];
    ['cart-drawer-items', 'cart-items'].forEach(function (tag) {
      var el = document.querySelector(tag);
      if (el && typeof el.getSectionsToRender === 'function') {
        try { lists.push(el.getSectionsToRender()); } catch (e) {}
      }
    });
    return lists;
  }

  function rerender() {
    var lists = sectionLists();
    var jobs = lists.map(function (list) {
      var ids = list.map(function (s) { return s.section; }).filter(Boolean).slice(0, 5);
      if (!ids.length) return Promise.resolve();
      var url = window.location.pathname + '?sections=' + encodeURIComponent(ids.join(','));
      return origFetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          list.forEach(function (s) {
            var html = sections && sections[s.section];
            if (!html) return;
            var src = new DOMParser().parseFromString(html, 'text/html').querySelector('#' + s.id);
            if (!src) return;
            document.querySelectorAll('#' + s.id).forEach(function (el) { el.innerHTML = src.innerHTML; });
          });
        })
        .catch(function () {});
    });
    return Promise.all(jobs);
  }

  /* --- Geschenk-Position markieren (Mengenauswahl ausblenden) ------------- */

  // Shopify haengt den Kauf-X-erhalte-Y-Rabatt mit 0 EUR auch an die
  // KAUF-Positionen (gemessen 21.10.: "TRY ME SET ... GRATIS-GESCHENK"). Das
  // Theme listet jede Zuordnung als Rabatt-Etikett auf. Etiketten mit 0 EUR
  // werden hier ausgeblendet; die Reihenfolge der <li> entspricht der
  // Reihenfolge von line_level_discount_allocations.
  function decorate(cart) {
    document.querySelectorAll('.vp-gift-line').forEach(function (el) {
      el.classList.remove('vp-gift-line');
    });
    (cart.items || []).forEach(function (item, i) {
      ['CartDrawer-Item-' + (i + 1), 'CartItem-' + (i + 1)].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el) return;
        if (isGift(item)) el.classList.add('vp-gift-line');
        var allocs = item.line_level_discount_allocations || [];
        var lis = el.querySelectorAll('ul.discounts > li');
        if (lis.length !== allocs.length) return;
        allocs.forEach(function (a, j) {
          lis[j].style.display = a.amount > 0 ? '' : 'none';
        });
      });
    });
  }

  /* --- Pruefen und angleichen -------------------------------------------- */

  function check() {
    if (busy) { again = true; return; }
    busy = true;

    getCart().then(function (cart) {
      var items = cart.items || [];
      var gifts = items.filter(isGift);
      var others = items.filter(function (i) { return !isGift(i); });
      var sum = others.reduce(function (s, i) { return s + (i.final_line_price || 0); }, 0);

      var wanted = !cfg.excluded &&
        inWindow() &&
        (!cfg.currency || cart.currency === cfg.currency) &&
        others.length > 0 &&
        sum >= cfg.threshold;

      // Hatte der Warenkorb das Geschenk, und es ist weg, obwohl es noch
      // zusteht? Dann hat es der Kunde selbst herausgenommen.
      if (wanted && !gifts.length && ss(true, KEY_HAD) === '1') {
        ss(false, KEY_DECLINED, '1');
      }
      if (!wanted) ss(false, KEY_DECLINED, null);

      var job = null;

      if (wanted && !gifts.length && ss(true, KEY_DECLINED) !== '1') {
        var props = {};
        props[FLAG] = '1';
        if (cfg.propKey) props[cfg.propKey] = cfg.propValue || '';
        job = postJSON(cartBase() + '/add.js', {
          items: [{ id: cfg.variantId, quantity: 1, properties: props }]
        });
      } else if (wanted && gifts.length) {
        // genau eine Position mit Menge 1
        var fixes = [];
        gifts.forEach(function (g, idx) {
          var q = idx === 0 ? 1 : 0;
          if (g.quantity !== q) fixes.push({ id: g.key, quantity: q });
        });
        if (fixes.length) {
          job = fixes.reduce(function (p, f) {
            return p.then(function () { return postJSON(cartBase() + '/change.js', f); });
          }, Promise.resolve());
        }
      } else if (!wanted && gifts.length) {
        job = gifts.reduce(function (p, g) {
          return p.then(function () { return postJSON(cartBase() + '/change.js', { id: g.key, quantity: 0 }); });
        }, Promise.resolve());
      }

      if (!job) {
        ss(false, KEY_HAD, gifts.length ? '1' : null);
        decorate(cart);
        return null;
      }

      return job
        .catch(function () {})
        .then(rerender)
        .then(getCart)
        .then(function (c) {
          var has = (c.items || []).some(isGift);
          ss(false, KEY_HAD, has ? '1' : null);
          decorate(c);
        });
    }).catch(function () {})
      .then(function () {
        busy = false;
        if (again) { again = false; schedule(300); }
      });
  }

  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(check, ms);
  }

  /* --- Ausloeser ---------------------------------------------------------- */

  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (CART_RE.test(url)) {
      // Erst nachdem das Theme seine Antwort verarbeitet hat.
      p.then(function () { schedule(600); }, function () {});
    }
    return p;
  };

  document.addEventListener('cart-drawer:open', function () { schedule(50); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(200); });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(400); });
  } else {
    schedule(400);
  }
})();
